/* eslint-disable import/prefer-default-export */
import UserRole, { UserRoleStrings } from 'enums/UserRole'
import i18n from 'i18n'
import { SuggestedUserInfo } from 'features/suggestedUsers/types'

export const isExecutive = (role: UserRoleStrings) => {
  const executiveRoles = [UserRole.ROLE_BUSINESS_USER]
  return !executiveRoles.includes(role)
}

export const handleLiveReportSubscriber = (value?: SuggestedUserInfo) => {
  if (!value) {
    return null
  }

  const { userProfileId, userRole } = value

  let msg
  if (userProfileId === '-1') {
    msg = i18n.t('addAsExecutive')
  } else if (!isExecutive(userRole)) {
    msg = i18n.t('upgradeToExecutive')
  }
  return msg
}
